import { Suspense, useEffect, useState } from "react";
import { Link, useOutlet } from "react-router-dom";
import { MenuProps } from "antd";

import SubHeader from "components/SubHeader";
import usePermission from "utils/hooks/usePermission";
import useProfile from "utils/hooks/useProfile";
import { PermissionType, UserType } from "constants/enum";

const items: MenuProps["items"] = [
  {
    key: "history",
    label: <Link to="/transfer-coin/history">Lịch sử chuyển coin</Link>,
  },
  {
    key: "transfer",
    label: <Link to="/transfer-coin/transfer">Chuyển coin</Link>,
  },
];

export default function TransferCoinWrapper() {
  const outlet = useOutlet();
  const { permissions, fetchingPermissions } = usePermission();
  const { profile, fetchingProfile } = useProfile(true);
  const [curItems, setCurItems] = useState<MenuProps["items"]>([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let itemsTemp = items;
    if (profile && profile?.userType === UserType.SUPER_ADMIN) {
      return setCurItems(items);
    }
    if (permissions?.data && !fetchingPermissions) {
      if (
        permissions?.data?.includes(PermissionType.TRANSFER_COIN_SYSTEM_VIEW)
      ) {
        itemsTemp = itemsTemp?.filter((item) => item?.key !== "transfer");
      }
      return setCurItems(itemsTemp);
    }
  }, [fetchingPermissions, fetchingProfile]);

  return (
    <div className="sub-wrapper">
      <div className="sub-menu">
        <SubHeader items={curItems} />
      </div>
      <Suspense fallback={null}>{outlet}</Suspense>
    </div>
  );
}
